namespace dg.domain.KPI {
	export const enum KPIValueSantiment {
		Neutral = 0,
		Positive = 1,
		Negative = 2
    }
    export const enum KPIValueTrend {
        Unchanged = 0,
        Up = 1,
        Down = 2,
    }
}
namespace dg.restfulApi {
	export const enum ResourceType {
		DomainObjectProperty = 0,
		DomainObject = 1,
		DomainList = 2,
		Composite = 3,
		DomainTypeProperty = 4,
		DomainType = 5,
		RootMetadata = 6
	}
	export const enum ResultValueType {
		DomainObject = 0,
		DomainList = 1,
		ValueObject = 2,
		Composite = 3,
		Metadata = 4
	}
}

